import { get, post } from "./config";

const InsuranceApplication = {
  get: () => get("/v1/insuranceapplications"),
  create: (data) => post("/v1/insuranceapplications", data),
};

export default InsuranceApplication;
